import axios from "axios";
import React, { useState } from "react";
import { SEARCH_API } from "../../config/config";
import { MdClose } from "react-icons/md";

const BlogSearchBar = ({ setSearchResults, setSearchQuery, setVisibleCount }) => {
    const [query, setQuery] = useState("");
    const [isFocused, setIsFocused] = useState(false);

    const fetchSearchData = async (searchText) => {
        try {
            const response = await axios.post(SEARCH_API, { search: searchText });

            if (response.data && response.data.DATA) {
                const filteredResults = response.data.DATA.filter((item) => item.type === "blog");
                setSearchResults(filteredResults);
            } else {
                setSearchResults([]);
            }
        } catch (error) {
            console.error("Error fetching search results:", error);
            setSearchResults([]);
        }
    };

    const handleInputChange = async (e) => {
        const searchText = e.target.value;
        setQuery(searchText);
        setSearchQuery(searchText);

        if (searchText.trim() !== "") {
            await fetchSearchData(searchText);
        } else {
            setSearchResults([]);
        }
    };

    const handleClearInput = (e) => {
        e.stopPropagation();
        setQuery("");
        setSearchQuery("");
        setSearchResults([]);
        setVisibleCount(12); // Reset visible count when clearing input
    };

    return (
        <div className="position-relative">
            <div className={`dropdown-menu-custom-2 ${isFocused ? "full-width" : ""}`}>
                <div className="search-bar-container">
                    <input
                        type="text"
                        value={query}
                        onChange={handleInputChange}
                        placeholder="Search..."
                        className={`search-input ${isFocused ? "full-width" : ""}`}
                        onFocus={() => setIsFocused(true)}
                        onBlur={(e) => {
                            if (!e.relatedTarget || !e.relatedTarget.classList.contains("search-clear-icon")) {
                                setIsFocused(false);
                            }
                        }}
                    />
                    {query && (
                        <MdClose
                            className="search-clear-icon"
                            onMouseDown={(e) => e.preventDefault()}
                            onClick={handleClearInput}
                            tabIndex="0"
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

export default BlogSearchBar;
